import { render, staticRenderFns } from "./TableauView.vue?vue&type=template&id=3a43785c&scoped=true"
import script from "./TableauView.vue?vue&type=script&lang=js"
export * from "./TableauView.vue?vue&type=script&lang=js"
import style0 from "./TableauView.vue?vue&type=style&index=0&id=3a43785c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a43785c",
  null
  
)

export default component.exports